const SAMPLE_SIZE = 16;

export function sampleAverageColor(src: string): Promise<null | string> {
  return new Promise((resolve) => {
    const image = new Image();

    image.crossOrigin = "anonymous";
    image.addEventListener("error", () => resolve(null));
    image.addEventListener("load", () => {
      try {
        const canvas = document.createElement("canvas");

        canvas.width = SAMPLE_SIZE;
        canvas.height = SAMPLE_SIZE;
        const context = canvas.getContext("2d");

        if (!context) return resolve(null);

        context.drawImage(image, 0, 0, SAMPLE_SIZE, SAMPLE_SIZE);
        const { data } = context.getImageData(0, 0, SAMPLE_SIZE, SAMPLE_SIZE);
        let red = 0;
        let green = 0;
        let blue = 0;

        for (let offset = 0; offset < data.length; offset += 4) {
          red += data[offset] ?? 0;
          green += data[offset + 1] ?? 0;
          blue += data[offset + 2] ?? 0;
        }
        const pixels = data.length / 4;

        resolve(
          `rgb(${Math.round(red / pixels)}, ${Math.round(green / pixels)}, ${Math.round(blue / pixels)})`,
        );
      } catch {
        resolve(null);
      }
    });
    image.src = src;
  });
}
